import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import Form from 'containers/SignupPages/AuthByContractEpargnEmail/Form';
import messages from 'containers/SignupPages/AuthUnvalidUserSendEmail/messages';
import { AUTH_EPARGN_SMS_UNVALID_USER } from 'containers/SignupPages/constants';
import Header from 'containers/SignupPages/Header';
import { getEmailSelector } from 'store/user/selectors';
import { translate } from 'helpers/intl';

export type AuthByContractEmailType = {
  intl: IntlShape;
  onSubmitStep: Function;
  isLoading: boolean;
  setSignupStep: Function;
};

const AuthUnvalidUserSendEmail = (props: AuthByContractEmailType) => {
  return (
    <React.Fragment>
      <Header
        title={translate({ ...messages.title }, props)}
        subTitle={`${translate({ ...messages.subTitle }, props)} :`}
      />
      <Form
        isLoading={props.isLoading}
        onClickPrevious={() => {
          props.setSignupStep(AUTH_EPARGN_SMS_UNVALID_USER);
        }}
        onSubmitStep={props.onSubmitStep}
      />
    </React.Fragment>
  );
};

const mapStateToProps = createStructuredSelector<any, { email: string }>({
  email: getEmailSelector,
});

export default connect(mapStateToProps)(injectIntl(AuthUnvalidUserSendEmail));
